module.exports = __webpack_public_path__ + "static/eightwaves.c1a90b7e.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/eightwaves.png
// module id = 1494
// module chunks = 19843951674672